import { render, staticRenderFns } from "./MasteredResponsibilityTable.vue?vue&type=template&id=f868068e&scoped=true"
import script from "./MasteredResponsibilityTable.vue?vue&type=script&lang=js"
export * from "./MasteredResponsibilityTable.vue?vue&type=script&lang=js"
import style0 from "./MasteredResponsibilityTable.vue?vue&type=style&index=0&id=f868068e&prod&lang=css"
import style1 from "./MasteredResponsibilityTable.vue?vue&type=style&index=1&id=f868068e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f868068e",
  null
  
)

export default component.exports